import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Swal from "sweetalert2";
import {
  companyManagementUrl,
  customerservice,
  loanManagementUrl,
  setupManagementUrl,
} from "../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../data/DynamicServiceNew/jsondynamicservice";
import { CircularProgress } from "@mui/material";
import axios from "axios";

const BookLoan = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  // const customersData = [
  //   { id: '36991073', name: 'Lilian Kilani', email: 'fulusi@gmail.com', phone: '0798706353', branch: 'Kitengela', loanLimit: 3000, createdAt: 'Nov 29, 2021' },
  //   // Add more customer data as needed
  // ];
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCustomer, setFilteredCustomer] = useState(null);
  const [amount, setAmount] = useState("");
  const [loanProductSelected, setLoanProductSelected] = useState([]);
  const [loanProduct, setLoanProduct] = useState([]);
  const [customers, setCustomers] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [branchData, setBranchData] = useState("");
  const [installmentError, setInstallmentError] = useState("");
  const [noOfInstallments, setNoOfInstallments] = useState(0);
  const base_url = customerservice.uri;

  const resetForm = () => {
    setSearchTerm("");
    setFilteredCustomer(null);
    setAmount("");
    setLoanProductSelected("");
    setNoOfInstallments("");
    setInstallmentError("");

  };
  useEffect(() => {
    
    const delayDebounceFn = setTimeout(async () => {
      if (searchTerm.length >= 10) {
        const variations = [
          searchTerm,
          searchTerm.startsWith("0") ? searchTerm.replace(/^0/, "254") : null,
          searchTerm.startsWith("254") ? searchTerm.replace(/^254/, "0") : null,
          searchTerm.startsWith("01") ? searchTerm.replace(/^01/, "254") : null, // Handle numbers starting with 01
        ].filter(Boolean);

        setLoadingSearch(true);

        try {
          let foundCustomer = null;

          for (const number of variations) {
            const query = `
              query {
                customersByColumnValues(customer: {mobileNumber: "${number}"}) {
                  error
                  results
                }
              }
            `;

            const token = localStorage.getItem("token");
            const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

            const response = await axios.post(
              base_url,
              { query },
              {
                headers: {
                  Authorization: formattedToken,
                  "Content-Type": "application/json",
                },
              }
            );

            const data = response.data?.data?.customersByColumnValues;

            if (data?.results) {
              const parsedResults = JSON.parse(data?.results);
              if (parsedResults.length) {
                foundCustomer = parsedResults[0];
                break; // Exit the loop if customer is found
              }
            } else if (data?.error) {
              Swal.fire("Error", data.error || "Unexpected error", "error");
              break; // Exit the loop on server-side error
            }
          }

          if (foundCustomer) {
            setFilteredCustomer(foundCustomer); // Add balance and collateral to customer object
          } else {
            Swal.fire(
              "Customer Not Found",
              "Customer does not exist with any variations.",
              "warning"
            );
          }
          const params = { companyId: parseInt(companyId),            isSecuredProduct: true,
            isSecuredProduct: false};
          const productResponse = await fetchJsonDynamic(
            "individualProducts",
            "parameters",
            params,
            setupManagementUrl.uri
          );
     
          const allProduct = JSON.parse(productResponse.results) || [];
      
          // Filter regions based on selected company ID
    
          setLoanProduct(allProduct || []);

          if (!foundCustomer) {
            Swal.fire(
              "Customer Not Found",
              "Customer does not exist with any variations.",
              "warning"
            );
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while searching. Please try again.",
            "error"
          );
          console.error("Error fetching customer by mobile number:", error);
        } finally {
          setLoadingSearch(false);
        }
      } else {
        setFilteredCustomer(null);
        setLoadingSearch(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchJsonDynamic(
        "allCustomers",
        null,
        null,
        customerservice.uri
      );
      const allCustomers = JSON.parse(response.results) || [];

      const params = { companyId: parseInt(companyId) };
      const productResponse = await fetchJsonDynamic(
        "individualProducts",
        "parameters",
        params,
        setupManagementUrl.uri
      );
 
      const allProduct = JSON.parse(productResponse.results) || [];
     

      // Filter regions based on selected company ID

      setLoanProduct(allProduct || []);
    };
    fetchData();
  }, []);
  const handleAppraisalSubmit = async () => {
    // Validate installments if dynamic installment is enabled
    if (selectedLoanProduct.IsdynamicInstallment === 1) {
      const min = selectedLoanProduct.MinimumTerm || 0;
      const max = selectedLoanProduct.MaximumTerm || Infinity;
      const numInstallments = parseInt(noOfInstallments, 10);

      if (!noOfInstallments || isNaN(numInstallments)) {
        setInstallmentError("Please enter a valid number of installments");
        return;
      }

      if (numInstallments < min || numInstallments > max) {
        setInstallmentError(`Installments must be between ${min} and ${max}`);
        return;
      }
    }

    setLoadingSubmit(true); // Start loading when the form is submitted

    try {
      const mutationData = {
        p_CustomerId: filteredCustomer.Id,
        p_Principle: parseInt(amount),
        p_ProductId: loanProductSelected,
        p_Installment: parseInt(noOfInstallments, 10) || null,
      };

      const response = await executeAnyMutation(
        "insertLoanApplications",
        mutationData,
        "loanApplication",
        false,
        loanManagementUrl.uri
      );
      const parsedResults = JSON.parse(response.results);
      if (parsedResults) {
        if (parsedResults[0] === "Loan Booked Successfully") {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: parsedResults,
          });
          // Reset form upon successful submission
          resetForm();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: parsedResults,
          });
        }
      } else if (response.errors) {
        throw new Error(
          response.errors[0].Error || "An internal server error occurred."
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
      resetForm();
    } finally {
      setLoadingSubmit(false); // End loading after the process
    }
  };



  const date = new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const selectedLoanProduct =
    loanProduct.find((product) => product.Id === loanProductSelected) || {};

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h5">Book A Loan</Typography>
      <TextField
        label="Search Customer by customer Phone number "
        placeholder="Enter search criteria"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchTerm}
        //onChange={handleSearchChange}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          endAdornment: loadingSearch && (
            <CircularProgress size={24} sx={{ marginRight: 2 }} />
          ),
        }}
      />

      {filteredCustomer && (
        <>
          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Customer Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Customer Name:</strong> {filteredCustomer.FirstName}{" "}
                    {filteredCustomer.OtherNames}{" "}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong> {filteredCustomer.EmailAddress}
                  </Typography>
                  <Typography>
                    <strong>ID Number:</strong>{" "}
                    {filteredCustomer.IdNoOrPassport}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Mobile Number:</strong>{" "}
                    {filteredCustomer.MobileNumber}
                  </Typography>
                  <Typography>
                    <strong>Branch:</strong>{" "}
                    {filteredCustomer.BranchName}
                  </Typography>
                  <Typography>
                    <strong>Date Created:</strong>{" "}
                    {filteredCustomer.DateCreated
                      ? formatter.format(new Date(filteredCustomer.DateCreated)) // Format the date
                      : "N/A"}
                  </Typography>

                  <Typography>
                    <strong>Current Loan Limit:</strong>{" "}
                    {filteredCustomer.LoanLimit || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Loan Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Loan Product</InputLabel>
                    <Select
                      value={loanProductSelected}
                      onChange={(e) => setLoanProductSelected(e.target.value)}
                      defaultValue=""
                    >
                      <MenuItem value="" disabled>
                        Select Loan Product
                      </MenuItem>
                      {loanProduct.map((company) => (
                        <MenuItem key={company.Id || 0} value={company.Id || 0}>
                          {company.Name || ""}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Amount to Disburse"
                    placeholder="Enter Amount"
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Grid>
              </Grid>
              {/* Show No of Installments only if IsDynamicInstallment === 1 */}
              {selectedLoanProduct.IsdynamicInstallment === 1 && (
                 <Grid container spacing={2} sx={{ mt: 2 }}>
                 <Grid item xs={12} sm={4}>
                   <TextField
                     fullWidth
                     variant="outlined"
                     label="Minimum Installment"
                     value={selectedLoanProduct.MinimumTerm || ""}
                     disabled
                   />
                 </Grid>
                 <Grid item xs={12} sm={4}>
                   <TextField
                     fullWidth
                     variant="outlined"
                     label="Maximum Installment"
                     value={selectedLoanProduct.MaximumTerm || ""}
                     disabled
                   />
                 </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="No of Installments"
                      placeholder="Enter Number of Installments"
                      value={noOfInstallments}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Only check if it's a valid number (not empty or numeric)
                        if (value === "" || /^\d*$/.test(value)) {
                          setNoOfInstallments(value);
                          setInstallmentError(""); // Clear error when user types
                        }
                      }}
                      error={!!installmentError}
                      helperText={installmentError || `Enter between ${selectedLoanProduct.MinimumTerm} and ${selectedLoanProduct.MaximumTerm}`}
                    />
                  </Grid>
                </Grid>
              )}
            </CardContent>
          </Card>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleAppraisalSubmit}
            // disabled={loadingSubmit} // Disable button when loading
            disabled={loadingSubmit || 
              (selectedLoanProduct.IsdynamicInstallment === 1 && 
                (!noOfInstallments || 
                 noOfInstallments < selectedLoanProduct.MinInstallments || 
                 noOfInstallments > selectedLoanProduct.MaxInstallments))}

          >
            {loadingSubmit ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit For Appraisal"
            )}
          </Button>
        </>
      )}
    </Box>
  );
};

export default BookLoan;